// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  /*
  .table {
      height: 705px;
  } */
}
:host .header-panel {
  background-color: var(--headerBackground);
  color: var(--headerColor);
  position: absolute;
  top: 0px;
  left: 0px;
  height: 36px;
  width: 100%;
  text-align: center;
  line-height: 36px;
  border-bottom: 1px solid var(--headerBorder);
}
:host .header-panel mat-icon {
  display: inline-block;
  vertical-align: text-top;
}
:host .work-panel {
  position: absolute;
  top: 37px;
  left: 0px;
  right: 0px;
  bottom: 0px;
}
:host .container {
  display: flex;
  flex-direction: column;
  min-width: 300px;
  position: absolute;
  bottom: 0px;
  top: 0px;
  left: 0px;
  right: 0px;
}
:host .mat-table {
  overflow: auto;
  height: 100%;
}
:host .mat-row {
  min-height: 40px;
  height: 43px;
}
:host .mat-cell {
  font-size: 13px;
}
:host .mat-header-row {
  top: 0;
  position: sticky;
  z-index: 1;
}
:host .mat-header-cell {
  font-size: 15px;
}
:host .mat-column-select {
  overflow: visible;
  flex: 0 0 80px;
}
:host .mat-column-name {
  flex: 1 1 120px;
}
:host .mat-column-receiver {
  flex: 1 1 460px;
}
:host .mat-column-delay {
  flex: 0 0 60px;
}
:host .mat-column-interval {
  flex: 0 0 80px;
}
:host .mat-column-type {
  flex: 0 0 80px;
}
:host .mat-column-enabled {
  flex: 0 0 100px;
}
:host .mat-column-subscriptions {
  flex: 3 1 200px;
}
:host .mat-column-remove {
  flex: 0 0 60px;
}
:host .selectidthClass {
  flex: 0 0 50px;
}
:host .message-error {
  display: inline-block;
  color: red;
}
:host .my-header-filter ::ng-deep .mat-sort-header-button {
  display: block;
  text-align: left;
  margin-top: 5px;
}
:host .my-header-filter ::ng-deep .mat-sort-header-arrow {
  top: -12px;
  right: 20px;
}
:host .my-header-filter-input {
  display: block;
  margin-top: 4px;
  margin-bottom: 6px;
  padding: 3px 1px 3px 2px;
  border-radius: 2px;
}`, "",{"version":3,"sources":["webpack://./src/app/notifications/notification-list/notification-list.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/notifications/notification-list/notification-list.component.scss"],"names":[],"mappings":"AAAA;EAqCI;;;KAAA;AChCJ;ADJI;EACI,yCAAA;EACA,yBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,4CAAA;ACMR;ADHI;EACI,qBAAA;EACA,wBAAA;ACKR;ADFI;EACI,kBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;ACIR;ADDI;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;ACGR;ADII;EACI,cAAA;EACA,YAAA;ACFR;ADKI;EACI,gBAAA;EACA,YAAA;ACHR;ADMI;EACI,eAAA;ACJR;ADOI;EACI,MAAA;EACA,gBAAA;EACA,UAAA;ACLR;ADQI;EACI,eAAA;ACNR;ADSI;EACI,iBAAA;EACA,cAAA;ACPR;ADUI;EACI,eAAA;ACRR;ADWI;EACI,eAAA;ACTR;ADYI;EACI,cAAA;ACVR;ADaI;EACI,cAAA;ACXR;ADcI;EACI,cAAA;ACZR;ADeI;EACI,eAAA;ACbR;ADgBI;EACI,eAAA;ACdR;ADiBI;EACI,cAAA;ACfR;ADkBI;EACI,cAAA;AChBR;ADmBI;EACI,qBAAA;EACA,UAAA;ACjBR;ADoBI;EACI,cAAA;EACA,gBAAA;EACA,eAAA;AClBR;ADqBI;EACI,UAAA;EACA,WAAA;ACnBR;ADsBI;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,wBAAA;EACA,kBAAA;ACpBR","sourcesContent":[":host {\n    .header-panel {\n        background-color: var(--headerBackground);\n        color: var(--headerColor);\n        position: absolute;\n        top: 0px;\n        left: 0px;\n        height: 36px;\n        width: 100%;\n        text-align: center;\n        line-height: 36px;\n        border-bottom: 1px solid var(--headerBorder);\n    }\n\n    .header-panel mat-icon {\n        display: inline-block;\n        vertical-align: text-top;\n    }\n\n    .work-panel {\n        position: absolute;\n        top: 37px;\n        left: 0px;\n        right: 0px;\n        bottom: 0px;\n    }\n\n    .container {\n        display: flex;\n        flex-direction: column;\n        min-width: 300px;\n        position: absolute;\n        bottom: 0px;\n        top: 0px;\n        left:0px;\n        right:0px;\n    }\n    /*\n    .table {\n        height: 705px;\n    } */\n\n    .mat-table {\n        overflow: auto;\n        height: 100%;\n    }\n\n    .mat-row {\n        min-height: 40px;\n        height: 43px;\n    }\n\n    .mat-cell {\n        font-size: 13px;\n    }\n\n    .mat-header-row {\n        top: 0;\n        position: sticky;\n        z-index: 1;\n    }\n\n    .mat-header-cell {\n        font-size: 15px;\n    }\n\n    .mat-column-select {\n        overflow: visible;\n        flex: 0 0 80px;\n    }\n\n    .mat-column-name {\n        flex: 1 1 120px;\n    }\n\n    .mat-column-receiver {\n        flex: 1 1 460px;\n    }\n\n    .mat-column-delay {\n        flex: 0 0 60px;\n    }\n\n    .mat-column-interval {\n        flex: 0 0 80px;\n    }\n\n    .mat-column-type {\n        flex: 0 0 80px;\n    }\n\n    .mat-column-enabled {\n        flex: 0 0 100px;\n    }\n\n    .mat-column-subscriptions {\n        flex: 3 1 200px;\n    }\n\n    .mat-column-remove {\n        flex: 0 0 60px;\n    }\n\n    .selectidthClass{\n        flex: 0 0 50px;\n    }\n\n    .message-error {\n        display: inline-block;\n        color:red;\n    }\n\n    .my-header-filter ::ng-deep .mat-sort-header-button {\n        display: block;\n        text-align: left;\n        margin-top: 5px;\n    }\n\n    .my-header-filter ::ng-deep .mat-sort-header-arrow {\n        top: -12px;\n        right: 20px;\n    }\n\n    .my-header-filter-input {\n        display: block;\n        margin-top: 4px;\n        margin-bottom: 6px;\n        padding: 3px 1px 3px 2px;\n        border-radius: 2px;\n    }\n}",":host {\n  /*\n  .table {\n      height: 705px;\n  } */\n}\n:host .header-panel {\n  background-color: var(--headerBackground);\n  color: var(--headerColor);\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  height: 36px;\n  width: 100%;\n  text-align: center;\n  line-height: 36px;\n  border-bottom: 1px solid var(--headerBorder);\n}\n:host .header-panel mat-icon {\n  display: inline-block;\n  vertical-align: text-top;\n}\n:host .work-panel {\n  position: absolute;\n  top: 37px;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n}\n:host .container {\n  display: flex;\n  flex-direction: column;\n  min-width: 300px;\n  position: absolute;\n  bottom: 0px;\n  top: 0px;\n  left: 0px;\n  right: 0px;\n}\n:host .mat-table {\n  overflow: auto;\n  height: 100%;\n}\n:host .mat-row {\n  min-height: 40px;\n  height: 43px;\n}\n:host .mat-cell {\n  font-size: 13px;\n}\n:host .mat-header-row {\n  top: 0;\n  position: sticky;\n  z-index: 1;\n}\n:host .mat-header-cell {\n  font-size: 15px;\n}\n:host .mat-column-select {\n  overflow: visible;\n  flex: 0 0 80px;\n}\n:host .mat-column-name {\n  flex: 1 1 120px;\n}\n:host .mat-column-receiver {\n  flex: 1 1 460px;\n}\n:host .mat-column-delay {\n  flex: 0 0 60px;\n}\n:host .mat-column-interval {\n  flex: 0 0 80px;\n}\n:host .mat-column-type {\n  flex: 0 0 80px;\n}\n:host .mat-column-enabled {\n  flex: 0 0 100px;\n}\n:host .mat-column-subscriptions {\n  flex: 3 1 200px;\n}\n:host .mat-column-remove {\n  flex: 0 0 60px;\n}\n:host .selectidthClass {\n  flex: 0 0 50px;\n}\n:host .message-error {\n  display: inline-block;\n  color: red;\n}\n:host .my-header-filter ::ng-deep .mat-sort-header-button {\n  display: block;\n  text-align: left;\n  margin-top: 5px;\n}\n:host .my-header-filter ::ng-deep .mat-sort-header-arrow {\n  top: -12px;\n  right: 20px;\n}\n:host .my-header-filter-input {\n  display: block;\n  margin-top: 4px;\n  margin-bottom: 6px;\n  padding: 3px 1px 3px 2px;\n  border-radius: 2px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
